// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var List        = require("bs-platform/lib/js/list.js");
var $$Array     = require("bs-platform/lib/js/array.js");
var Block       = require("bs-platform/lib/js/block.js");
var Curry       = require("bs-platform/lib/js/curry.js");
var Input       = require("../ffi/Input");
var React       = require("react");
var $$String    = require("bs-platform/lib/js/string.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

((require('./QuickAddMeal.css')));

var component = ReasonReact.reducerComponent("QuickAddMeal");

function make(meals, onAdd, _) {
  var renderSuggestion = function (suggestions) {
    return $$Array.of_list(List.map((function (suggestion) {
                      return React.createElement("div", {
                                  key: suggestion.id,
                                  className: "qam-suggestion",
                                  onClick: (function () {
                                      return Curry._1(onAdd, suggestion);
                                    })
                                }, React.createElement("strong", {
                                      className: "qam-suggestion-title"
                                    }, suggestion.name), React.createElement("div", {
                                      className: "qam-suggestion-tags"
                                    }, $$Array.of_list(List.map((function (tag) {
                                                return React.createElement("div", {
                                                            key: tag.id,
                                                            className: "qam-suggestion-tag"
                                                          }, tag.name);
                                              }), suggestion.categories))));
                    }), suggestions));
  };
  var renderDefaultSuggestion = function (input) {
    if (input === "") {
      return null;
    } else {
      return React.createElement("div", {
                  className: "qam-suggestion",
                  onClick: (function () {
                      var input$1 = input;
                      return Curry._1(onAdd, {
                                  id: "x",
                                  name: input$1,
                                  timestamp: Date.now(),
                                  categories: /* [] */0
                                });
                    })
                }, "Add ", React.createElement("strong", undefined, $$String.trim(input)), "...");
    }
  };
  var newrecord = component.slice();
  newrecord[/* render */9] = (function (self) {
      var match = self[/* state */2][/* showOverlay */2];
      return React.createElement("div", {
                  className: "qam"
                }, React.createElement("input", {
                      className: "qam-input",
                      placeholder: "Add / Input your meal",
                      value: self[/* state */2][/* input */0],
                      onFocus: (function () {
                          return Curry._1(self[/* send */4], /* ShowOverlay */0);
                        }),
                      onChange: (function ($$event) {
                          return Curry._1(self[/* send */4], /* TypeMeal */[Input.value($$event)]);
                        })
                    }), match !== 0 ? React.createElement("div", undefined, React.createElement("div", {
                            className: "qam-suggestion-overlay",
                            onClick: (function () {
                                return Curry._1(self[/* send */4], /* HideOverlay */1);
                              })
                          }), React.createElement("div", {
                            className: "qam-suggestions"
                          }, renderSuggestion(self[/* state */2][/* suggestions */1]), renderDefaultSuggestion(self[/* state */2][/* input */0]))) : null);
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* input */"",
              /* suggestions : [] */0,
              /* showOverlay : false */0
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        if (action !== 0) {
          return /* Update */Block.__(0, [/* record */[
                      /* input */state[/* input */0],
                      /* suggestions */state[/* suggestions */1],
                      /* showOverlay : false */0
                    ]]);
        } else {
          return /* Update */Block.__(0, [/* record */[
                      /* input */state[/* input */0],
                      /* suggestions */state[/* suggestions */1],
                      /* showOverlay : true */1
                    ]]);
        }
      } else {
        var text = action[0];
        var suggestions = text === "" ? /* [] */0 : List.filter((function (meal) {
                    return +$$String.lowercase(meal.name).includes($$String.lowercase(text));
                  }))(meals);
        return /* Update */Block.__(0, [/* record */[
                    /* input */text,
                    /* suggestions */suggestions,
                    /* showOverlay */state[/* showOverlay */2]
                  ]]);
      }
    });
  return newrecord;
}

exports.component = component;
exports.make      = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/components/QuickAddMeal.re
// module id = 380
// module chunks = 0